<div class="log-detail-dialog crm-dialog">
  <h2 mat-dialog-title>
    <mat-icon>bug_report</mat-icon>
    Log részletek
    <button mat-icon-button (click)="close()" aria-label="Bezárás" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="dialog-content">
    @if (isLoading) {
      <div class="loading-state">
        <mat-spinner diameter="32"></mat-spinner>
        <span>Betöltés...</span>
      </div>
    }

    @if (errorMessage && !isLoading) {
      <div class="error-state">
        <mat-icon>error_outline</mat-icon>
        <span>{{ errorMessage }}</span>
      </div>
    }

    @if (detail && !isLoading) {
      <div class="detail-body">
        <!-- Meta sor -->
        <div class="meta-grid">
          <div class="meta-item">
            <span class="label">Időpont</span>
            <span class="value">{{ detail.timestamp | date:'yyyy-MM-dd HH:mm:ss' }}</span>
          </div>
          <div class="meta-item">
            <span class="label">Szint</span>
            <span class="level-chip" [class]="'level-' + detail.level.toLowerCase()">
              {{ detail.level }}
            </span>
          </div>
          <div class="meta-item">
            <span class="label">Logger</span>
            <span class="value mono">{{ detail.logger_name }}</span>
          </div>
          @if (detail.user_name || detail.user_id) {
            <div class="meta-item">
              <span class="label">Felhasználó</span>
              <span class="value">{{ detail.user_name || ('ID: ' + detail.user_id) }}</span>
            </div>
          }
          @if (detail.request_path) {
            <div class="meta-item">
              <span class="label">Kérés</span>
              <span class="value mono">
                {{ detail.request_method }} {{ detail.request_path }}
              </span>
            </div>
          }
        </div>
        <!-- Üzenet -->
        <section class="section">
          <h3>Üzenet</h3>
          <pre class="message-block">{{ detail.message }}</pre>
        </section>
        <!-- Traceback -->
        @if (detail.traceback) {
          <section class="section">
            <h3>Stack trace</h3>
            <pre class="traceback-block">{{ detail.traceback }}</pre>
          </section>
        }
        <!-- Request body -->
        @if (detail.request_body) {
          <section class="section">
            <h3>Request body</h3>
            <pre class="body-block">{{ formatBody(detail.request_body) }}</pre>
          </section>
        }
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions-row">
    <app-delete-icon-button
      tooltip="Bejegyzés törlése"
      (clicked)="deleteLog()">
    </app-delete-icon-button>
    <button mat-stroked-button (click)="close()">Bezárás</button>
  </mat-dialog-actions>
</div>
